var render, staticRenderFns
import script from "./CrtCompany.vue?vue&type=script&lang=js&"
export * from "./CrtCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66b39bf4')) {
      api.createRecord('66b39bf4', component.options)
    } else {
      api.reload('66b39bf4', component.options)
    }
    
  }
}
component.options.__file = "src/views/Company/UpdateInfo/CrtCompany.vue"
export default component.exports